export const achievementName_1 = 'flash_start';
export const achievementName_2 = 'flash_end';
export const achievementName_3 = 'mcq_start';
export const achievementName_4 = 'mcq_one_correct';
export const achievementName_5 = 'mcq_end';
export const achievementName_6 = 'simulated_one';
export const achievementName_7 = 'simulated_two';
export const achievementName_10 = 'video_section_1';
export const achievementName_11 = 'video_section_2';
export const achievementName_12 = 'video_section_3';
export const achievementName_13 = 'video_section_4';
export const achievementName_14 = 'video_section_5';

export const achievement_1_details = 'Congrats! You have viewed your first FLASHCARD!';
export const achievement_2_details = 'Congrats! You have viewed all FLASHCARDS, Keep up the Good Work!';
export const achievement_3_details = 'Make sure you note any tough topics and then study those in the book or videos';
export const achievement_4_details = 'Great Job! You just answered correctly, Keep going!';
export const achievement_5_details = 'Congrats! Nice Work!';
export const achievement_6_details_less_75 =
  'Congratulations you finished it. Make sure you study hard before the next attempt!';
export const achievement_6_details_more_75 =
  'Congratulations. You did it. Keep in mind we recommend getting to scores of 95% or better!';
export const achievement_7_details = 'Great Job you finished another Test!';

export const achievement_8_details = 'Congrats! You have viewed 50 FLASHCARDS';
export const achievement_9_details = 'Congrats! You have answered 25 Questions';
export const achievement_10_details = 'Great Job you finished another section of the videos!';

export const achievementDetails_1 = {
  achievement_id: '1',
  achievement_title: 'FIRST FLASHCARD',
  achievement_detail: 'You have viewed your first FLASHCARD.',
  status: '0',
};
export const achievementDetails_2 = {
  achievement_id: '2',
  achievement_title: 'ALL FLASHCARDS',
  achievement_detail: 'You have viewed all FLASHCARDS.',
  status: '0',
};
export const achievementDetails_3 = {
  achievement_id: '3',
  achievement_title: 'FIRST QUESTION',
  achievement_detail: 'You have answered your first question.',
  status: '0',
};
export const achievementDetails_4 = {
  achievement_id: '4',
  achievement_title: 'FIRST CORRECT QUESTION',
  achievement_detail: 'You have answered your first question correctly.',
  status: '0',
};
export const achievementDetails_5 = {
  achievement_id: '5',
  achievement_title: 'ALL QUESTIONS',
  achievement_detail: 'You have answered all the questions.',
  status: '0',
};
export const achievementDetails_6 = {
  achievement_id: '6',
  achievement_title: 'FIRST SIMULATED TEST',
  achievement_detail: 'You have completed your first simulated exam.',
  status: '0',
};
export const achievementDetails_7 = {
  achievement_id: '7',
  achievement_title: 'SECOND SIMULATED TEST',
  achievement_detail: 'You have completed your second simulated exam',
  status: '0',
};
